import { useCallback } from 'react';

interface IUseWebShare {
	url?: string;
	text?: string;
	title?: string;
	files?: File[];
}

const useWebShare = () => {
	const webShare = useCallback(async (props: IUseWebShare) => {
		const { text, title, url, files } = props;
		try {
			await navigator.share({ url, text, title, files });
		} catch (err) {
			return;
		}
	}, []);

	return { webShare };
};

export default useWebShare;
